import React, { Component } from 'react';
import {Redirect,Link} from 'react-router-dom';
import $ from 'jquery';
import {
  Button,
  ButtonGroup,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

class AppPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dropdownOpen: new Array(2).fill(false),
			dropdownOpen1: new Array(2).fill(false),
			dropdownOpen2: new Array(2).fill(false),
		}
		this.toggle = this.toggle.bind(this);
		this.toggle1 = this.toggle1.bind(this);
		this.toggle2 = this.toggle2.bind(this);
	}
	
	toggle(i) {
		const newArray = this.state.dropdownOpen.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen: newArray
		});
	}
	toggle1(i) {
		const newArray = this.state.dropdownOpen1.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen1: newArray
		});
	}
	toggle2(i) {
		const newArray = this.state.dropdownOpen2.map((element, index) => { return (index === i ? !element : false); });
		this.setState({
		  dropdownOpen2: newArray
		});
	}
	
  render() {
	
    return (
		<nav className="navbar navbar-expand-lg navbar-light bg-light nav_top">
		  <a className="navbar-brand" href="javascript:;"><i className="fa fa-mobile"></i>&nbsp; App / Web Content</a>
		  <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
			<span className="navbar-toggler-icon"></span>
		  </button>
		  <div className="collapse navbar-collapse" id="navbarSupportedContent">
			<ul className="navbar-nav mr-auto">
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen2[0]} toggle={() => { this.toggle2(0); }}>
				<DropdownToggle caret color="setup">
					Setup
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/app/VersionSetup" className="dropdown-item" >Version</Link>
						<Link to="/app/MenuSetup" className="dropdown-item" >Menu</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen[0]} toggle={() => { this.toggle(0); }}>
				<DropdownToggle caret color="pages">
					Pages
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/page/allpage" className="dropdown-item" >All Pages</Link>
						<Link to="/page/addpage" className="dropdown-item" >Add Page</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item dropdown">
				<ButtonDropdown isOpen={this.state.dropdownOpen1[0]} toggle={() => { this.toggle1(0); }}>
				<DropdownToggle caret color="events">
					Events
				</DropdownToggle>
					<DropdownMenu>
						<Link to="/events/addtype" className="dropdown-item" >Event Type</Link>
						<Link to="/events/addevent" className="dropdown-item" >Add Event</Link>
						<Link to="/events/event" className="dropdown-item" >Event List</Link>
						<Link to="/events/eventreport" className="dropdown-item" >Reports</Link>
					</DropdownMenu>
				</ButtonDropdown>
			  </li>
			  <li className="nav-item active">
				<Link to="/announcements" className="nav-link" >Announcement</Link>
			  </li>
			  <li className="nav-item active">
					<Link to="/gallery" className="nav-link" >Gallery</Link>
			  </li>
			  <li className="nav-item active">
					<Link to="/slider" className="nav-link" >Slider</Link>
			  </li>
			</ul>
		  </div>
		</nav>
    )
  }
}

export default AppPage;


// WEBPACK FOOTER //
// ./src/views/AppPage/AppPage.js